import { renderNavigator } from "./grid-value-formatters";

export const SalesOrdheaderTable = [
  {
    headerName: "id",
    field: "id",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    cellRenderer: renderNavigator,
    minWidth: 90,
  },

  {
    headerName: "actualshipdate",
    field: "actualshipdate",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },

  {
    headerName: "actionitem",
    field: "actionitem",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },

  {
    headerName: "billingstatus",
    field: "billingstatus",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
];
export const JournallinesTable = [];
